import React from "react";
import { Route, Routes } from "react-router-dom";

import EmailConfirmation from "@/components/screens/EmailConfirmation";
import { EMAIL_CONFIRMATION_MESSAGES } from "@/messages/emailConfirmation/email-confirmation.messages";

const EmailConfirmationPage: React.FC = () => {
  return (
    <Routes>
      <Route
        path=":token/:lang"
        element={<EmailConfirmation messages={EMAIL_CONFIRMATION_MESSAGES} />}
      />
      <Route path="/" element={<EmailConfirmation messages={EMAIL_CONFIRMATION_MESSAGES} />} />
    </Routes>
  );
};

export default EmailConfirmationPage;
